import onElementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElementExistRunOnce('.maintenance-records-report-table', () => {
  void (async () => {
    try {
      const { default: Component } = await import('./internal/maintenance-records-report-table');
      await Promise.resolve(Component());
    } catch (error) {
      console.error(error); // eslint-disable-line no-console -- report failed page initialization
    }
  })();
});

onElementExistRunOnce('.maintenance-records-page-show', () => {
  void (async () => {
    try {
      const { default: Component } = await import('./internal/maintenance-record-show-page');
      await Promise.resolve(Component());
    } catch (error) {
      console.error(error); // eslint-disable-line no-console -- report failed page initialization
    }
  })();
});
